export class AdjustmentsReport {
  client_adjustments: number;
  freighter_adjustments: number;
  mover_adjustments: number;
}
